import { StyledLeftColumn } from './DashboardLeftColumn.styled'

interface DashboardLeftColumnProps {
  children: React.ReactNode
}

export const DashboardLeftColumn = ({ children }: DashboardLeftColumnProps) => {
  return <StyledLeftColumn>{children}</StyledLeftColumn>
}
